/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import cn from 'classnames'

import Navbar from '../../components/Navbar'

import styles from './CustomerTabs.module.scss'
import CustomerTabOrders from '../../containers/tabs/CustomerTabOrders'
import OrderListControlBar from '../../containers/tabs/OrderListControlBar'

import { preOrdersRequested, ordersDeltasRequested, orderDetailsRequested } from '../../actions/order'
import { clearRemoteOrderTotal } from '../../actions/orderTotalRemote'
import { setActiveRevenueCenter } from '../../actions/revenueCenter'
import { setActiveCustomer } from '../../actions/suites/customer'
import { fetchCustomerPayments } from '../../actions/suites/customerPayment'

import { makeGetAttendantStandUuids } from '../../selectors/attendant'
import { getCurrentEventId } from '../../selectors/events'

import useInterval from '../../hooks/useInterval'

import VNPusher, {
  CHANNEL_PRIVATE_POS_VENUE,
  PUSHER_EVENT_ORDER_MUTATION,
  BIND_CUSTOMER_TABS_MUTATION } from '../../pusher'
import { fetchResourcesForOrderingPreferences } from '../../actions/shared'

const CustomerTabs = ({ fetchPreOrders, onMount, pollOrderDeltas, updateRemoteOrder, unsyncedRemoteIds, initialPreOrderLoadComplete, salesEventId, standUuids, className }) => {
  const classNames = cn(styles.customerTabs, className)

  useEffect(() => {
    onMount()

    return () => {
      VNPusher.unsubscribe(CHANNEL_PRIVATE_POS_VENUE)
    }
  }, [])

  useEffect(() => {
    if (unsyncedRemoteIds.length > 9) {
      return fetchPreOrders(salesEventId, standUuids)
    }

    unsyncedRemoteIds.forEach(orderId =>{
      updateRemoteOrder(orderId)
    })
  }, [unsyncedRemoteIds])

  useInterval(() => { pollOrderDeltas() }, 15000)

  return (
    <div className={classNames}>
      <Navbar className={styles.navbar} showEventHeader={true} />
      <div>
        <OrderListControlBar className={styles.orderListControlBar} />
      </div>
      <div className={styles.content}>
        <CustomerTabOrders className={styles.customerTabOrders} />
      </div>
    </div>
  )
}

const mapStateToProps = (state, ownProps) => {
  const salesEventId = getCurrentEventId(state)
  const getAttendantStandUuids = makeGetAttendantStandUuids()
  const standUuids = getAttendantStandUuids(state)

  return {
    salesEventId,
    standUuids,
    unsyncedRemoteIds: state.order?.unsyncedRemoteIds ?? [],
    initialPreOrderLoadComplete: state.order?.initialPreOrderLoadComplete ?? false
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    fetchPreOrders: (salesEventId, standUuids) => {
      dispatch(preOrdersRequested(salesEventId, standUuids))
    },
    updateRemoteOrder: (orderUuid) => {
      dispatch(orderDetailsRequested(orderUuid))
    },
    onMount: () => {
      dispatch(setActiveCustomer(undefined))
      dispatch(setActiveRevenueCenter(undefined))
      dispatch(clearRemoteOrderTotal())
      dispatch(fetchCustomerPayments())
      dispatch(fetchResourcesForOrderingPreferences())

      VNPusher.subscribe(CHANNEL_PRIVATE_POS_VENUE)
      VNPusher.bind(BIND_CUSTOMER_TABS_MUTATION, CHANNEL_PRIVATE_POS_VENUE, PUSHER_EVENT_ORDER_MUTATION, (data) => {
        if (data.mutation_type === "refund" && data.mutation_applied) {
          dispatch(orderDetailsRequested(data.order_uuid))
        }
      })
    },
    pollOrderDeltas: () => {
      dispatch(ordersDeltasRequested())
    },
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(CustomerTabs)
